import React from 'react'
import Hero from '../components/Hero'
import About from '../components/About'
import Features from '../components/Features'
import Features2 from '../components/Features2'
import RevenueShareModel from '../components/RevenueShareModel'
import DeepWhalesAI from '../components/DeepWhalesAI'

export default function Home() {
  return (
    <>
      <Hero />
      <About />
      <Features />
      <Features2 />
      <RevenueShareModel />
      <DeepWhalesAI />
    </>
  )
}
